<template>
  <!--
    COMPONENTE CONFIGURADO EXCLUSIVAMENTE PARA COLOMBIA
    Esta versión del sistema ERP está bloqueada para trabajar únicamente con parámetros de Colombia.
    No permite cambiar la configuración de país.
  -->
  <v-container fluid class="pa-6">
    <!-- KPI Cards Section -->
    <v-row class="mb-6">
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card elevation-0" outlined>
          <v-card-text class="pa-5">
            <div class="kpi-icon">
              <v-icon color="primary">mdi-domain</v-icon>
            </div>
            <div class="kpi-content">
              <div class="kpi-label">Total Proveedores</div>
              <div class="kpi-value">{{ totalSuppliers }}</div>
              <div class="kpi-subtitle">
                <v-icon x-small color="success">mdi-check-circle</v-icon>
                {{ activeSuppliers }} activos
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card elevation-0" outlined>
          <v-card-text class="pa-5">
            <div class="kpi-icon">
              <v-icon color="success">mdi-trending-up</v-icon>
            </div>
            <div class="kpi-content">
              <div class="kpi-label">Nuevos este mes</div>
              <div class="kpi-value">{{ newSuppliersThisMonth }}</div>
              <div class="kpi-subtitle">{{ monthGrowthRate }}% crecimiento</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card elevation-0" outlined>
          <v-card-text class="pa-5">
            <div class="kpi-icon">
              <v-icon color="info">mdi-map-marker-multiple</v-icon>
            </div>
            <div class="kpi-content">
              <div class="kpi-label">Ciudades</div>
              <div class="kpi-value">{{ uniqueCities }}</div>
              <div class="kpi-subtitle">{{ topCity }} principal</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card elevation-0" outlined>
          <v-card-text class="pa-5">
            <div class="kpi-icon">
              <v-icon color="purple">mdi-clipboard-check-outline</v-icon>
            </div>
            <div class="kpi-content">
              <div class="kpi-label">Datos Completos</div>
              <div class="kpi-value">{{ completeContactPercentage }}%</div>
              <div class="kpi-subtitle">{{ needContactUpdate }} pendientes</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Main Content Card -->
    <v-card class="main-card elevation-0" outlined>
      <!-- Header with Actions -->
      <v-card-title class="pa-0">
        <v-toolbar flat class="minimal-toolbar">
          <h2 class="section-title">Gestión de Proveedores</h2>
          <v-spacer></v-spacer>

          <!-- Search and Filters -->
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar..."
            single-line
            hide-details
            dense
            outlined
            clearable
            class="mr-4 search-field"
            style="max-width: 300px"
          ></v-text-field>

          <!-- <v-select
            v-model="filterRegime"
            :items="regimenOptions"
            label="Régimen"
            clearable
            dense
            outlined
            hide-details
            style="max-width: 150px"
            class="mr-4"
          ></v-select> -->

          <v-btn color="primary" @click="newForm">
            <v-icon left>mdi-plus</v-icon>
            Nuevo
          </v-btn>

          <v-btn icon class="ml-2" @click="exportToExcel" title="Exportar a Excel">
            <v-icon>mdi-file-excel</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card-title>

      <!-- Data Table -->
      <v-data-table
        :headers="minimalHeaders"
        :items="filteredSuppliers"
        :items-per-page="10"
        :search="search"
        item-key="codigo"
        sort-by="nombre"
        :loading="loading_status"
        class="minimal-table"
        @click:row="editItem"
        :footer-props="{
          'items-per-page-options': [10, 20, 50, 100],
        }"
      >
        <!-- Supplier Info -->
        <template v-slot:item.supplier="{ item }">
          <div class="supplier-info">
            <div class="supplier-name">
              <v-icon small class="mr-2" color="primary">mdi-domain</v-icon>
              {{ item.nombre }}
            </div>
            <div class="supplier-details">
              <span class="mr-3">
                <v-icon x-small class="mr-1">mdi-identifier</v-icon>
                {{ item.codigo }}
              </span>
              <!-- <span v-if="item.compania">{{ item.compania }}</span> -->
            </div>
          </div>
        </template>

        <!-- Contact Info -->
        <template v-slot:item.contact="{ item }">
          <div class="contact-info">
            <div v-if="item.telefono || item.celular" class="contact-phones">
              <v-icon x-small class="mr-1">mdi-phone</v-icon>
              {{ item.telefono || item.celular }}
            </div>
            <div v-if="item.email" class="contact-email">
              <v-icon x-small class="mr-1">mdi-email</v-icon>
              {{ item.email }}
            </div>
            <div v-if="!item.telefono && !item.celular && !item.email" class="grey--text">
              Sin contacto
            </div>
          </div>
        </template>

        <!-- Location -->
        <template v-slot:item.location="{ item }">
          <div class="location-info">
            <div v-if="item.ciudad">
              <v-icon x-small class="mr-1">mdi-map-marker</v-icon>
              {{ item.ciudad }}
            </div>
            <div
              v-if="item.direccion"
              class="text-caption grey--text text-truncate"
              style="max-width: 200px"
            >
              {{ item.direccion }}
            </div>
          </div>
        </template>

        <!-- Regime -->
        <!-- <template v-slot:item.regimen="{ item }">
          <v-chip
            :color="item.regimen === '05' ? 'success' : 'warning'"
            text-color="white"
            small
            label
          >
            {{ getRegimenText(item.regimen) }}
          </v-chip>
        </template> -->

        <!-- Contact Person -->
        <template v-slot:item.contacto="{ item }">
          <div v-if="item.contacto">
            <v-icon x-small class="mr-1">mdi-account</v-icon>
            {{ item.contacto }}
          </div>
          <span v-else class="grey--text">-</span>
        </template>

        <!-- Status -->
        <template v-slot:item.status="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" :color="getStatusColor(item)" small>
                {{ getStatusIcon(item) }}
              </v-icon>
            </template>
            <span>{{ getStatusText(item) }}</span>
          </v-tooltip>
        </template>

        <!-- No data -->
        <template v-slot:no-data>
          <div class="text-center py-12">
            <v-icon size="64" color="grey lighten-2">mdi-domain</v-icon>
            <h3 class="text-h6 mt-4 grey--text">No hay proveedores registrados</h3>
            <v-btn color="primary" class="mt-4" @click="newForm">
              <v-icon left>mdi-plus</v-icon>
              Agregar Primer Proveedor
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <!-- Edit/New Dialog -->
    <v-dialog v-model="dialog" max-width="800px" scrollable>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card class="elevation-0">
          <v-toolbar flat class="minimal-toolbar">
            <h3 class="dialog-title">{{ editingItem ? "Editar" : "Nuevo" }} Proveedor</h3>
            <v-spacer></v-spacer>
            <v-btn icon @click="closeDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text class="pa-6">
            <!-- Basic Information -->
            <div class="form-section">
              <h4 class="form-section-title">
                <v-icon small class="mr-2">mdi-information</v-icon>
                Información Básica
              </h4>
              <v-row>
                <v-col cols="12">
                  <v-alert type="info" dense text class="mt-2" v-if="!editingItem">
                    <v-icon small class="mr-2">mdi-information</v-icon>
                    Si deja el código vacío, se generará automáticamente (PROV0001,
                    PROV0002, etc.)
                  </v-alert>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="supplier.codigo"
                    label="Código del Proveedor"
                    :rules="f_codigo_validacion"
                    :disabled="editingItem"
                    outlined
                    dense
                    prepend-inner-icon="mdi-barcode"
                    hide-details="auto"
                    placeholder="Ej: 1 → 0001, 123 → 0123, o vacío"
                    hint="Vacío = automático, número se rellena con ceros (ej: 1 → 0001)"
                    persistent-hint
                    :readonly="editingItem"
                    @input="validarCodigoInput"
                    @blur="formatearCodigo"
                    maxlength="4"
                    counter="4"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="8">
                  <v-text-field
                    v-model="supplier.nombre"
                    label="Nombre del Proveedor"
                    :rules="f_required"
                    outlined
                    dense
                    prepend-inner-icon="mdi-account"
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    v-model="supplier.typeId"
                    :items="dynamicSettings.documentTypes"
                    label="Tipo de Identificación"
                    item-value="code"
                    item-text="name"
                    :rules="f_required"
                    outlined
                    dense
                    prepend-inner-icon="mdi-card-account-details"
                    hide-details="auto"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="supplier.id_nit"
                    label="Número de Identificación"
                    :rules="f_required"
                    outlined
                    dense
                    prepend-inner-icon="mdi-identifier"
                    @input="validarDocumentoProveedor"
                    @blur="validarDocumentoProveedor"
                    @keypress="filterDocumentInput"
                    :append-icon="validationIcon"
                    :success="validationStatus === 'success'"
                    :error="false"
                    :success-messages="validationMessage"
                    :hint="validationMessage"
                    persistent-hint
                  ></v-text-field>
                </v-col>

                <!-- <v-col cols="12">
                  <v-text-field
                    v-model="supplier.compania"
                    label="Nombre de la Compañía"
                    outlined
                    dense
                    prepend-inner-icon="mdi-office-building"
                    hide-details="auto"
                  ></v-text-field>
                </v-col> -->
              </v-row>
            </div>

            <!-- Contact Information -->
            <div class="form-section">
              <h4 class="form-section-title">
                <v-icon small class="mr-2">mdi-contacts</v-icon>
                Información de Contacto
              </h4>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="supplier.contacto"
                    label="Persona de Contacto"
                    outlined
                    dense
                    prepend-inner-icon="mdi-account-circle"
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="supplier.email"
                    label="Correo Electrónico"
                    :rules="f_email"
                    outlined
                    dense
                    prepend-inner-icon="mdi-email"
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="supplier.telefono"
                    label="Teléfono"
                    outlined
                    dense
                    prepend-inner-icon="mdi-phone"
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="supplier.celular"
                    label="Celular"
                    outlined
                    dense
                    prepend-inner-icon="mdi-cellphone"
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="supplier.fax"
                    label="Fax"
                    outlined
                    dense
                    prepend-inner-icon="mdi-fax"
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>

            <!-- Location Information -->
            <div class="form-section">
              <h4 class="form-section-title">
                <v-icon small class="mr-2">mdi-map-marker</v-icon>
                Ubicación
              </h4>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="supplier.direccion"
                    label="Dirección"
                    outlined
                    dense
                    prepend-inner-icon="mdi-map-marker"
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    v-model="supplier.departamento_id"
                    label="Departamento"
                    :items="dynamicSettings.departments"
                    item-value="id"
                    item-text="name"
                    outlined
                    dense
                    prepend-inner-icon="mdi-map"
                    hide-details="auto"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-autocomplete
                    v-model="selectedMunicipality"
                    label="Ciudad"
                    :items="dynamicSettings.municipalities"
                    item-value="id"
                    item-text="name"
                    outlined
                    dense
                    prepend-inner-icon="mdi-city"
                    hide-details="auto"
                    return-object
                    @change="handleMunicipalityChange"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    v-model="supplier.pais"
                    :items="paisesEuropeos"
                    label="País"
                    outlined
                    dense
                    prepend-inner-icon="mdi-flag"
                    hide-details="auto"
                  ></v-select>
                </v-col>
              </v-row>
            </div>

            <!-- Tax and Account Information -->
            <!-- <div class="form-section">
              <h4 class="form-section-title">
                <v-icon small class="mr-2">mdi-scale-balance</v-icon>
                Información Tributaria
              </h4>
              <v-row>
                <v-col cols="12" md="6">
                  <v-select
                    v-model="supplier.regimen"
                    :items="TaxLevelCodes"
                    label="Régimen Tributario"
                    item-text="text"
                    item-value="value"
                    outlined
                    dense
                    prepend-inner-icon="mdi-scale-balance"
                    hide-details="auto"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    v-model="supplier.typeaccount"
                    :items="typeaccountsID"
                    label="Tipo de Cuenta"
                    item-text="text"
                    item-value="value"
                    outlined
                    dense
                    prepend-inner-icon="mdi-account-multiple"
                    hide-details="auto"
                  ></v-select>
                </v-col>
              </v-row>
            </div> -->

            <!-- Observations -->
            <div class="form-section">
              <h4 class="form-section-title">
                <v-icon small class="mr-2">mdi-note-text</v-icon>
                Observaciones
              </h4>
              <v-row>
                <v-col cols="12">
                  <v-textarea
                    v-model="supplier.observaciones"
                    label="Observaciones"
                    outlined
                    dense
                    rows="3"
                    prepend-inner-icon="mdi-note-text"
                    hide-details="auto"
                  ></v-textarea>
                </v-col>
              </v-row>
            </div>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="pa-6">
            <v-spacer></v-spacer>
            <v-btn text @click="closeDialog"> Cancelar </v-btn>
            <v-btn
              color="primary"
              @click="saveSupplier"
              :loading="saving"
              :disabled="!valid"
            >
              <v-icon left>mdi-content-save</v-icon>
              {{ editingItem ? "Actualizar" : "Guardar" }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- Snackbar -->
    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="3000">
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">Cerrar</v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import { webserver } from "@/services/webserver.js";
import { fe_ws } from "@/services/webserver.js"; // Para Gateway DIAN
import createSupplier from "@/utils/createSupplier.js";
import settings from "../../utils/settings.js";
import countryUtils from "../../utils/countryUtils.js";

export default {
  data() {
    return {
      dynamicSettings: {
        documentTypes: [],
        departments: [],
        municipalities: [],
        liabilityTypes: [],
        organizationTypes: [],
        regimeTypes: [],
        vatRates: [],
      },
      // Form validation
      valid: false,
      f_required: [(v) => !!v || "Campo requerido"],
      f_email: [(v) => !v || /.+@.+\..+/.test(v) || "Formato de correo inválido"],
      
      // Validación específica para código de proveedor
      f_codigo_validacion: [
        (v) => {
          // Si está vacío, es válido (se genera automáticamente)
          if (!v || v.trim() === '') return true;
          
          // Si no está vacío, debe ser numérico
          if (!/^\d+$/.test(v.trim())) {
            return 'El código debe contener solo números';
          }
          
          // Máximo 4 dígitos
          if (v.trim().length > 4) {
            return 'El código no puede tener más de 4 dígitos';
          }
          
          return true;
        }
      ],

      // UI State
      loading_status: false,
      saving: false,
      dialog: false,
      editingItem: false,
      snackbar: false,
      snackbarText: "",
      snackbarColor: "info",

      // Search and filters
      search: "",
      filterRegime: null,

      // Data
      supplier_lst: [],
      supplier: {},
      selectedMunicipality: null,

      // Validation
      validationIcon: "",
      validationStatus: "",
      validationMessage: "",
      validationError: "",

      // Table configuration
      minimalHeaders: [
        { text: "Proveedor", value: "supplier", sortable: false, width: "30%" },
        { text: "Contacto", value: "contact", sortable: false, width: "25%" },
        { text: "Ubicación", value: "location", sortable: false, width: "20%" },

        { text: "Persona Contacto", value: "contacto", width: "10%" },
        {
          text: "Estado",
          value: "status",
          align: "center",
          sortable: false,
          width: "5%",
        },
      ],

      // Select options
      paisesEuropeos: [
        "Colombia",
      ],

      typeIds: [
        { value: "DNI", text: "DNI - Documento Nacional de Identidad" },
        { value: "NIE", text: "NIE - Número de Identidad de Extranjero" },
        { value: "PAS", text: "Pasaporte" },
        { value: "A", text: "NIF - Sociedad Anónima" },
        { value: "B", text: "NIF - Sociedad Limitada" },
        { value: "C", text: "NIF - Sociedad Colectiva" },
        { value: "D", text: "NIF - Sociedad Comanditaria" },
        { value: "E", text: "NIF - Comunidad de Bienes" },
        { value: "F", text: "NIF - Sociedad Cooperativa" },
        { value: "G", text: "NIF - Asociación" },
        { value: "H", text: "NIF - Comunidad de Propietarios" },
        { value: "J", text: "NIF - Sociedad Civil" },
        { value: "N", text: "NIF - Entidad Extranjera" },
        { value: "P", text: "NIF - Corporación Local" },
        { value: "Q", text: "NIF - Organismo Público" },
        { value: "R", text: "NIF - Congregación o Institución Religiosa" },
        { value: "S", text: "NIF - Órgano de la Administración" },
        { value: "U", text: "NIF - Unión Temporal de Empresas" },
        { value: "V", text: "NIF - Otros tipos" },
        { value: "W", text: "NIF - Establecimiento permanente" },
        { value: "VAT", text: "Número IVA (Otros países UE)" },
      ],

      // typeaccountsID: [
      //   { value: "1", text: "Persona Jurídica" },
      //   { value: "2", text: "Persona Natural" },
      // ],

      // TaxLevelCodes: [
      //   { value: "04", text: "Régimen Simple" },
      //   { value: "05", text: "Régimen Ordinario" },
      // ],

      // regimenOptions: [
      //   { value: "04", text: "Simple" },
      //   { value: "05", text: "Ordinario" },
      // ],
    };
  },

  watch: {
    "supplier.id_nit"() {
      // Validar informativamente mientras el usuario escribe
      if (this.dialog) {
        this.validarDocumentoProveedor();
      }
    },

    "supplier.typeId"(newVal, oldVal) {
      // Si el usuario cambia el tipo, revalidar informativamente
      if (oldVal && this.supplier.id_nit && this.dialog) {
        this.validarDocumentoProveedor();
      }
    },
  },

  computed: {
    // KPIs
    totalSuppliers() {
      return this.supplier_lst.length;
    },

    activeSuppliers() {
      // Asumimos que todos están activos si no hay campo 'active'
      return this.supplier_lst.filter((s) => s.active !== false).length;
    },

    newSuppliersThisMonth() {
      const now = new Date();
      const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);

      return this.supplier_lst.filter((supplier) => {
        if (!supplier.created_at) return false;
        const createdDate = new Date(supplier.created_at);
        return createdDate >= firstDayOfMonth;
      }).length;
    },

    monthGrowthRate() {
      if (this.totalSuppliers === 0) return 0;

      const now = new Date();
      const lastMonthEnd = new Date(now.getFullYear(), now.getMonth(), 0);

      const suppliersLastMonth = this.supplier_lst.filter((supplier) => {
        if (!supplier.created_at) return true; // Contar como existente si no hay fecha
        const createdDate = new Date(supplier.created_at);
        return createdDate <= lastMonthEnd;
      }).length;

      if (suppliersLastMonth === 0) return 100;

      const growth = (this.newSuppliersThisMonth / suppliersLastMonth) * 100;
      return Math.round(growth * 10) / 10;
    },

    uniqueCities() {
      const cities = this.supplier_lst
        .filter((s) => s.ciudad)
        .map((s) => s.ciudad.trim())
        .filter((city) => city !== "");
      return new Set(cities).size;
    },

    topCity() {
      const cityCount = {};

      this.supplier_lst.forEach((s) => {
        if (s.ciudad && s.ciudad.trim() !== "") {
          const city = s.ciudad.trim();
          cityCount[city] = (cityCount[city] || 0) + 1;
        }
      });

      if (Object.keys(cityCount).length === 0) return "Sin datos";

      const sortedCities = Object.entries(cityCount).sort(([, a], [, b]) => b - a);

      return sortedCities[0] ? sortedCities[0][0] : "Sin datos";
    },

    completeContactPercentage() {
      if (this.totalSuppliers === 0) return 0;

      const complete = this.supplier_lst.filter(
        (s) =>
          s.telefono?.trim() ||
          (s.celular?.trim() && s.email?.trim() && s.direccion?.trim())
      ).length;

      return Math.round((complete / this.totalSuppliers) * 100);
    },

    needContactUpdate() {
      return this.supplier_lst.filter(
        (s) =>
          (!s.telefono?.trim() && !s.celular?.trim()) ||
          !s.email?.trim() ||
          !s.direccion?.trim()
      ).length;
    },

    filteredSuppliers() {
      let filtered = this.supplier_lst;

      if (this.filterRegime) {
        filtered = filtered.filter((s) => s.regimen === this.filterRegime);
      }

      return filtered;
    },
  },

  mounted() {
    this.loadDynamicSettings();
    this.get_colombia_municipalities();
    this.get_supplier();
  },

  methods: {
    loadDynamicSettings() {
      try {
        console.log("🌍 Cargando configuraciones dinámicas...");

        // Cargar settings dinámicos
        this.setting = settings();

        // Cargar configuraciones específicas por país
        this.dynamicSettings = {
          documentTypes: countryUtils.getDocumentTypes(),
          departments: countryUtils.getDepartments(),
          municipalities: [], // Se cargarán desde la BD con get_colombia_municipalities
          liabilityTypes: countryUtils.getLiabilityTypes(),
          organizationTypes: countryUtils.getOrganizationTypes(),
          regimeTypes: countryUtils.getRegimeTypes(),
          vatRates: countryUtils.getVatRates(),
        };

        // Cargar países disponibles
        this.availableCountries = countryUtils.getAvailableCountries();

        console.log("✅ Configuraciones dinámicas cargadas:", {
          country: countryUtils.getCurrentCountryCode(),
          documentsCount: this.dynamicSettings.documentTypes.length,
          departmentsCount: this.dynamicSettings.departments.length,
        });
      } catch (error) {
        console.error("❌ Error cargando configuraciones dinámicas:", error);
        this.showNotification("Error cargando configuraciones del país", "error");
      }
    },

    get_colombia_municipalities() {
      const qry = {
        store: window.store.store_id,
        table: "settings",
        filters: [{ field: "tableName", operator: "=", value: "municipalities" }],
      };

      this.loading_status = true;

      fe_ws("get_table", qry, (data) => {
        this.loading_status = false;
        if (data && Array.isArray(data)) {
          // Mapear los datos al formato esperado
          this.dynamicSettings.municipalities = data.map((municipality) => ({
            code: municipality.code,
            name: municipality.name,
            id: municipality.id,
          }));

          // Si ya hay un ciudad_cod guardado, buscar y seleccionar el municipio
          if (this.supplier.ciudad_cod) {
            this.selectedMunicipality = this.dynamicSettings.municipalities.find(
              (m) =>
                parseInt(m.id) === parseInt(this.supplier.ciudad_cod) ||
                m.code === String(this.supplier.ciudad_cod)
            );
          }
        }
      });
    },

    handleMunicipalityChange(municipality) {
      if (municipality && typeof municipality === "object") {
        this.supplier.ciudad = municipality.name;
        this.supplier.ciudad_cod = parseInt(municipality.id);
      }
    },

    // Data loading
    get_supplier() {
      this.loading_status = true;
      const qry = {
        store: window.store.store_id,
        table: "proveedores",
        filters: [
          {
            field: "store",
            operator: "=",
            value: window.store.store_id.substr(0, 6),
          },
        ],
      };

      webserver("get_table", qry, (data) => {
        this.loading_status = false;
        if (data) {
          this.supplier_lst = data;
        }
      });
    },

    // Validación de documentos españoles
    validarDocumentoProveedor() {
      // Limpiar validación si el campo está vacío
      if (!this.supplier.id_nit) {
        this.limpiarValidacion();
        return;
      }

      const documento = this.supplier.id_nit.trim();

      // Si el documento tiene menos de 9 caracteres, mostrar info neutral
      if (documento.length < 9) {
        this.validationIcon = "mdi-information-outline";
        this.validationStatus = "";
        this.validationMessage = `${documento.length}/9 caracteres`;
        this.validationError = "";
        return;
      }

      const resultado = this.validarDocumentoEspanol(documento);

      if (resultado.valido) {
        // Documento válido - mostrar como información positiva
        this.validationIcon = "mdi-check-circle";
        this.validationStatus = "success";
        this.validationMessage = `${resultado.tipoDetectado} válido`;
        this.validationError = "";

        // Auto-sugerir el tipo correcto (no obligatorio)
        if (resultado.tipoDetectado === "CIF") {
          const letra = documento.charAt(0);
          if (
            [
              "A",
              "B",
              "C",
              "D",
              "E",
              "F",
              "G",
              "H",
              "J",
              "N",
              "P",
              "Q",
              "R",
              "S",
              "U",
              "V",
              "W",
            ].includes(letra)
          ) {
            this.supplier.typeId = letra;
          } else {
            this.supplier.typeId = "VAT";
          }
          // Intentar VIES para empresas (opcional)
          this.consultarVIESBackground();
        } else if (resultado.tipoDetectado === "NIE") {
          this.supplier.typeId = "NIE";
        } else if (resultado.tipoDetectado === "DNI") {
          this.supplier.typeId = "DNI";
        }
      } else {
        // Documento no reconocido - mostrar como información neutral, NO como error
        this.validationIcon = "mdi-information-outline";
        this.validationStatus = ""; // No marcar como error
        this.validationMessage = "";

        // Mensajes informativos (no errores)
        if (documento.length === 9) {
          // Intentar detectar el tipo para dar información
          const patronDNI = /^[0-9]{8}[A-Z]$/;
          const patronNIE = /^[XYZ][0-9]{7}[A-Z]$/;
          const patronCIF = /^[A-Z][0-9]{7}[0-9A-Z]$/;

          if (patronDNI.test(documento.toUpperCase())) {
            this.validationMessage = "Formato DNI detectado";
          } else if (patronNIE.test(documento.toUpperCase())) {
            this.validationMessage = "Formato NIE detectado";
          } else if (patronCIF.test(documento.toUpperCase())) {
            this.validationMessage = "Formato CIF detectado";
          } else {
            this.validationMessage = "Formato personalizado";
          }
        } else {
          this.validationMessage = "Documento personalizado";
        }

        this.validationError = ""; // No mostrar errores
      }
    },

    validarDocumentoEspanol(documento) {
      if (!documento) return { valido: false };

      documento = documento.toUpperCase().trim();

      // Patrones de validación
      const patrones = {
        DNI: /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKE]$/,
        NIE: /^[XYZ][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]$/,
        CIF: /^[ABCDEFGHJNPQRSUVW][0-9]{7}[0-9A-J]$/,
      };

      // Detectar tipo
      let tipo = null;
      if (patrones.DNI.test(documento)) {
        tipo = "DNI";
      } else if (patrones.NIE.test(documento)) {
        tipo = "NIE";
      } else if (patrones.CIF.test(documento)) {
        tipo = "CIF";
      }

      if (!tipo) {
        return { valido: false, tipoDetectado: null };
      }

      // Validar según el tipo
      let valido = false;

      if (tipo === "DNI") {
        const numero = parseInt(documento.substr(0, 8));
        const letra = documento.substr(8, 1);
        const letrasValidas = "TRWAGMYFPDXBNJZSQVHLCKE";
        valido = letra === letrasValidas[numero % 23];
      } else if (tipo === "NIE") {
        let numero = documento;
        numero = numero.replace("X", "0").replace("Y", "1").replace("Z", "2");
        numero = parseInt(numero.substr(0, 8));
        const letra = documento.substr(8, 1);
        const letrasValidas = "TRWAGMYFPDXBNJZSQVHLCKE";
        valido = letra === letrasValidas[numero % 23];
      } else if (tipo === "CIF") {
        // Para proveedores, aceptamos CIF con formato correcto
        // La validación completa del dígito de control es compleja
        valido = true;
      }

      return {
        valido: valido,
        tipoDetectado: tipo,
      };
    },

    consultarVIESBackground() {
      // Consulta opcional a VIES para validación europea
      fetch("https://ai-bos.co/ws/vies/index.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ nif: this.supplier.id_nit }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success && data.valid) {
            this.validationMessage = "CIF válido - Verificado en VIES";
            this.validationIcon = "mdi-check-decagram";

            // Si VIES devuelve el nombre, podríamos sugerirlo
            if (data.name && !this.supplier.nombre) {
              this.supplier.nombre = data.name;
            }
          }
        })
        .catch(() => {
          // Ignorar errores de VIES - no es crítico
        });
    },

    limpiarValidacion() {
      this.validationIcon = "";
      this.validationStatus = "";
      this.validationMessage = "";
      this.validationError = "";
    },

    validarCodigoInput() {
      // Limpiar caracteres no numéricos del código
      if (this.supplier.codigo) {
        // Mantener solo números
        this.supplier.codigo = this.supplier.codigo.replace(/[^0-9]/g, '');
        
        // Limitar a 4 dígitos
        if (this.supplier.codigo.length > 4) {
          this.supplier.codigo = this.supplier.codigo.substring(0, 4);
        }
      }
    },

    // Método para rellenar con ceros a la izquierda cuando el campo pierde el foco
    formatearCodigo() {
      if (this.supplier.codigo && this.supplier.codigo.trim() !== '') {
        // Convertir a número y rellenar con ceros a la izquierda hasta 4 dígitos
        const numero = parseInt(this.supplier.codigo);
        if (!isNaN(numero)) {
          this.supplier.codigo = numero.toString().padStart(4, '0');
        }
      }
    },

    filterDocumentInput(evt) {
      evt = evt ? evt : window.event;
      const charCode = evt.which ? evt.which : evt.keyCode;

      // Permitir números
      if (charCode >= 48 && charCode <= 57) return true;

      // Permitir letras
      if ((charCode >= 65 && charCode <= 90) || (charCode >= 97 && charCode <= 122))
        return true;

      // Permitir guiones y otros caracteres especiales que podrían usarse en documentos
      if (charCode === 45 || charCode === 47 || charCode === 32) return true; // - / espacio

      // Permitir teclas de control (backspace, delete, etc)
      if (charCode < 32) return true;

      evt.preventDefault();
      return false;
    },

    // CRUD operations
    saveSupplier() {
      // Validar formulario incluyendo las nuevas reglas del código
      if (!this.$refs.form.validate()) return;

      this.saving = true;
      
      // Limpiar el código si está vacío (para que el backend genere uno automático)
      if (this.supplier.codigo && this.supplier.codigo.trim() === '') {
        this.supplier.codigo = null;
      }

      // Agregar store al proveedor
      this.supplier.store = window.store.store_id.substr(0, 6);

      // Si es nuevo, marcar como activo pero NO enviar created_at
      // El backend se encargará de asignar la fecha correcta
      if (!this.editingItem) {
        this.supplier.active = true;
        // NO enviar created_at - el backend lo manejará
      }

      // Establecer país por defecto si no se ha seleccionado
      if (!this.supplier.pais) {
        this.supplier.pais = "Colombia";
      }

      // Normalizar caracteres especiales
      const supplierData = {
        ...this.supplier,
        nombre: this.supplier.nombre ? this.supplier.nombre.normalize("NFC") : "",
        direccion: this.supplier.direccion
          ? this.supplier.direccion.normalize("NFC")
          : "",
        ciudad: this.supplier.ciudad ? this.supplier.ciudad.normalize("NFC") : "",
        pais: this.supplier.pais ? this.supplier.pais.normalize("NFC") : "",
        observaciones: this.supplier.observaciones
          ? this.supplier.observaciones.normalize("NFC")
          : "",
      };

      const qry = {
        store: window.store.store_id,
        table: "proveedores",
        data: [supplierData],
      };

      // USAR EL NUEVO ENDPOINT CON GENERACIÓN AUTOMÁTICA DE CÓDIGO
      const endpoint = "suppliers_update";

      webserver(endpoint, qry, (response) => {
        this.saving = false;
        this.dialog = false;

        // Manejar respuesta del nuevo servicio
        if (response && response.success !== false) {
          this.showNotification(
            this.editingItem ? "Proveedor actualizado" : "Proveedor creado exitosamente",
            "success"
          );

          // Si el servicio devuelve el código generado, mostrarlo
          if (response.data && response.data.length > 0 && response.data[0].codigo) {
            const codigoAsignado = response.data[0].codigo;
            if (!this.editingItem) {
              this.showNotification(`Código asignado automáticamente: ${codigoAsignado}`, "info");
            }
          }
        } else {
          this.showNotification(
            response.message || "Error al guardar proveedor",
            "error"
          );
        }

        this.get_supplier();
      });
    },

    editItem(item) {
      this.supplier = { ...item };
      this.editingItem = true;
      this.dialog = true;

      // Cargar la ciudad seleccionada si existe
      if (this.supplier.ciudad_cod) {
        this.selectedMunicipality = this.dynamicSettings.municipalities.find(
          (m) =>
            parseInt(m.id) === parseInt(this.supplier.ciudad_cod) ||
            m.code === String(this.supplier.ciudad_cod)
        );
      } else {
        this.selectedMunicipality = null;
      }
    },

    newForm() {
      this.supplier = createSupplier();
      this.supplier.pais = "Colombia"; // País por defecto
      this.supplier.codigo = ''; // Inicializar código vacío para generación automática
      this.selectedMunicipality = null; // Limpiar municipio seleccionado
      this.editingItem = false;
      this.valid = false;
      this.dialog = true;
    },

    closeDialog() {
      this.dialog = false;
      this.supplier = {};
      this.selectedMunicipality = null; // Limpiar municipio seleccionado
      this.editingItem = false;
      this.limpiarValidacion();
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },

    // Utility methods
    getRegimenText(regimen) {
      const regime = this.TaxLevelCodes.find((r) => r.value === regimen);
      return regime ? regime.text : "No especificado";
    },

    getStatusColor(item) {
      const hasPhone = item.telefono || item.celular;
      const hasEmail = item.email;
      const hasAddress = item.direccion;

      if (hasPhone && hasEmail && hasAddress) return "success";
      if (hasPhone || hasEmail) return "warning";
      return "error";
    },

    getStatusIcon(item) {
      const hasPhone = item.telefono || item.celular;
      const hasEmail = item.email;
      const hasAddress = item.direccion;

      if (hasPhone && hasEmail && hasAddress) return "mdi-check-circle";
      if (hasPhone || hasEmail) return "mdi-alert";
      return "mdi-alert-circle";
    },

    getStatusText(item) {
      const missing = [];
      if (!item.telefono && !item.celular) missing.push("teléfono");
      if (!item.email) missing.push("email");
      if (!item.direccion) missing.push("dirección");

      if (missing.length === 0) return "Información completa";
      return `Falta: ${missing.join(", ")}`;
    },

    showNotification(text, color = "info") {
      this.snackbarText = text;
      this.snackbarColor = color;
      this.snackbar = true;
    },

    exportToExcel() {
      const csv = this.generateCSV();
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `proveedores_${new Date().toISOString().split("T")[0]}.csv`;
      link.click();
      this.showNotification("Archivo exportado exitosamente", "success");
    },

    generateCSV() {
      const headers = [
        "Código",
        "Tipo ID",
        "Número ID",
        "Nombre",
        "Compañía",
        "Teléfono",
        "Celular",
        "Email",
        "Ciudad",
        "País",
        "Dirección",
        "Contacto",
        "Régimen",
      ];

      const rows = this.supplier_lst.map((s) => [
        s.codigo || "",
        s.typeId || "",
        s.id_nit || "",
        s.nombre || "",
        // s.compania || "",
        s.telefono || "",
        s.celular || "",
        s.email || "",
        s.ciudad || "",
        s.pais || "",
        s.direccion || "",
        s.contacto || "",
        this.getRegimenText(s.regimen) || "",
      ]);

      const csv = [headers, ...rows]
        .map((row) =>
          row.map((cell) => `"${cell.toString().replace(/"/g, '""')}"`).join(",")
        )
        .join("\n");

      return csv;
    },
  },
};
</script>

<style scoped>
/* KPI Cards */
.kpi-card {
  border: 1px solid #e0e0e0;
  transition: all 0.3s ease;
}

.kpi-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
}

.kpi-card .v-card__text {
  display: flex;
  align-items: center;
  gap: 16px;
}

.kpi-icon {
  background-color: #f5f5f5;
  border-radius: 12px;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.kpi-icon .v-icon {
  font-size: 28px !important;
}

.kpi-content {
  flex: 1;
}

.kpi-label {
  font-size: 0.875rem;
  color: #666;
  font-weight: 500;
  margin-bottom: 4px;
}

.kpi-value {
  font-size: 1.75rem;
  font-weight: 700;
  color: #333;
  line-height: 1.2;
}

.kpi-subtitle {
  font-size: 0.75rem;
  color: #999;
  margin-top: 4px;
  display: flex;
  align-items: center;
}

/* Main Card */
.main-card {
  border: 1px solid #e0e0e0;
}

.minimal-toolbar {
  border-bottom: 1px solid #e0e0e0;
  padding: 16px 24px;
}

.section-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
}

.dialog-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: #333;
}

/* Search Field */
.search-field >>> .v-input__control {
  background-color: white;
}

/* Data Table */
.minimal-table {
  border: none !important;
}

.minimal-table >>> .v-data-table__wrapper {
  border: none;
}

.minimal-table >>> thead tr th {
  background-color: #fafafa !important;
  font-weight: 600 !important;
  color: #666 !important;
  border-bottom: 2px solid #e0e0e0 !important;
  font-size: 0.875rem !important;
  padding: 16px !important;
}

.minimal-table >>> tbody tr {
  border-bottom: 1px solid #f0f0f0 !important;
  cursor: pointer;
  transition: background-color 0.2s;
}

.minimal-table >>> tbody tr:hover {
  background-color: #f5f5f5 !important;
}

.minimal-table >>> tbody tr td {
  padding: 16px !important;
  font-size: 0.875rem !important;
}

/* Supplier Info */
.supplier-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.supplier-name {
  font-weight: 500;
  color: #333;
  display: flex;
  align-items: center;
}

.supplier-details {
  font-size: 0.75rem;
  color: #666;
}

/* Contact Info */
.contact-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.contact-phones,
.contact-email {
  font-size: 0.75rem;
  color: #666;
  display: flex;
  align-items: center;
}

/* Location Info */
.location-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

/* Form Sections */
.form-section {
  margin-bottom: 24px;
}

.form-section:last-child {
  margin-bottom: 0;
}

.form-section-title {
  font-size: 0.875rem;
  font-weight: 600;
  color: #666;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
}

/* Loading */
.minimal-table >>> .v-data-table__progress {
  height: 2px !important;
}

/* Responsive */
@media (max-width: 960px) {
  .kpi-value {
    font-size: 1.5rem;
  }

  .section-title {
    font-size: 1.25rem;
  }

  .kpi-card .v-card__text {
    flex-direction: column;
    text-align: center;
  }

  .minimal-toolbar {
    flex-wrap: wrap;
    gap: 16px;
  }
}
</style>
